import { Avatar } from './Avatar';

export { Avatar };

export default Avatar;
